import Timer from './components/timer/Timer';
import Countdown from './components/countdown/Countdown';

function App() {
    return (
        <>
        <Timer />
        <Countdown />
        </>
    )
    
    
}

export default App;
